import script from "./workloads.vue?vue&type=script&setup=true&lang=ts"
export * from "./workloads.vue?vue&type=script&setup=true&lang=ts"

import "./workloads.vue?vue&type=style&index=0&id=1dd82064&lang=scss&scoped=true"

import exportComponent from "c:\\jenkins\\workspace\\Client_Windows_build\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1dd82064"]])

export default __exports__